import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Select } from 'primeng/select';
import { Paginator, PaginatorState } from 'primeng/paginator';

interface IPageSizeOption {
  label: string;
  value: number;
}

const PAGE_SIZE_OPTIONS: IPageSizeOption[] = [
  { label: '10', value: 10 },
  { label: '20', value: 20 },
  { label: '50', value: 50 },
  { label: '100', value: 100 },
];

/**
 * Presentational, offset-based paginator wrapping PrimeNG's paginator, with a
 * fixed "items per page" picker (10/20/50/100). Driven entirely by inputs;
 * emits the requested 1-based page and the chosen page size for the parent to
 * apply. Only used by agx-pivot-table. For cursor/server pagination use
 * ag1-pagination-v2 instead.
 */
@Component({
  selector: 'agx-paginator',
  templateUrl: './agx-paginator.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, Select, Paginator],
})
export class AgxPaginatorComponent {
  /** 0-based index of the first row on the current page (the pivot's pageLowerBound). */
  readonly first = input<number>(0);
  readonly rows = input<number>(20);
  readonly totalItems = input<number>(0);

  /** Emits the requested 1-based page number. */
  readonly pageChange = output<number>();

  /** Emits the newly selected page size. */
  readonly pageSizeChange = output<number>();

  readonly pageSizeOptions = PAGE_SIZE_OPTIONS;

  onPageChange(event: PaginatorState): void {
    // PrimeNG's page is 0-based; the pivot's page model is 1-based.
    this.pageChange.emit((event.page ?? 0) + 1);
  }
}
